/**
 * todo 多语言
 */

import React, { Component, Fragment, useContext } from 'react'
import { BaseComponentItemPropsType } from '@/typings/types'
import styles from './index.module.less'
import classnames from 'classnames'
import CountDown from './components/countdown'
import CouponLine from './components/couponLine'
import { receiveCoupon } from './apis'
import { CouponInfoModleItemType } from './types'
import { currencyCodeMap, currencySymbolMap } from '@/constant'
import { langMap, LangType } from './lang'
import Context from './context'
import Product from './components/product/index'
import { isDuApp } from '@/utils/appUtils/getDevice'
import appInstall from '@/utils/appUtils/appInstall'
import Jockey from '@/utils/jockey'
import { Toast } from 'antd-mobile'
import { withReactTrack } from '@du/analytics-sdk'
import { createTrackConfig } from './trackConfig'
import { formatSellData } from './utils'
import { px2rem } from '@/utils/styleUtils'

interface IState {
  buyDataSource: CouponInfoModleItemType[]
  sellDataSource: CouponInfoModleItemType[]
  expireTime: number
  /**
   *
   *  状态：1 领取成功   2 非新用户；3 已过期 4 未登录 5 已领完  6 已领取
   */
  state?: number
}

interface ItemProps {
  outerBgImg: string
  fontImg: string
  couponBgImg: string
  noBuyCouponBgImg: string
  bottomBgImg: string
  receivedImg: string
  overdueImg: string
  immerUseBtnMsg: string
  goHomeBuyBtnMsg: string
  buyTitle: string
  sellTitle: string
  tabItemContentBg?: string
}

interface IProps extends BaseComponentItemPropsType<ItemProps, Partial<IState>> {}

function Header(props: any) {
  return (
    <header className={styles['buy-counpon-top-wrapper']}>
      <div className={styles['header-line']}></div>
      <span className={styles['header-item-word']}>{props.children}</span>
      <div className={styles['header-line']}></div>
    </header>
  )
}

function BuyContent(props: { data: CouponInfoModleItemType[] }) {
  const { data = [] } = props
  const firstThirdData = data.slice(0, 3)
  const lastThirdData = data.slice(-3)
  return (
    <div className={styles['buy-counpon-content']}>
      <CouponLine isSell={false} key="1" data={firstThirdData} />
      <CouponLine isSell={false} key="2" data={lastThirdData} />
    </div>
  )
}

function BuyWrapper(props: { data: CouponInfoModleItemType[]; title: string }) {
  const { data, title } = props
  if (!data || !data.length) {
    return null
  }
  return (
    <div className={styles['buy-counpon-wrapper']}>
      <Header>{title}</Header>
      <BuyContent data={data} />
    </div>
  )
}

function SellContent(props: { data: CouponInfoModleItemType[] }) {
  const { data } = props
  const subDataArr = formatSellData(data)
  return (
    <Fragment>
      {subDataArr.map((ele, i) => (
        <CouponLine key={i} isSell={true} data={ele} />
      ))}
    </Fragment>
  )
}

function SellWrapper(props: { data: CouponInfoModleItemType[]; title: string }) {
  const { data, title } = props
  if (!data || !data.length) {
    return null
  }
  return (
    <div className={styles['sell-counpon-wrapper']}>
      <Header>{title}</Header>
      <SellContent data={data} />
    </div>
  )
}

function NewUserContent(props: {
  propsConfig: ItemProps
  onTimeEnd: any
  expireTime: number
  sellDataSource: CouponInfoModleItemType[]
  buyDataSource: CouponInfoModleItemType[]
  isOverdue: boolean
  state: number
}) {
  const {
    propsConfig,
    onTimeEnd,
    sellDataSource,
    buyDataSource,
    expireTime,
    isOverdue,
    state,
  } = props
  const statusImgSrcMap = {
    3: propsConfig.overdueImg,
    1: propsConfig.receivedImg,
    6: propsConfig.receivedImg,
  }
  const statusImgSrc = statusImgSrcMap[state]
  const { overdueMsg, fromOverdueWord, getDayWord, isQuery } = useContext(Context)

  function renderCountDown() {
    if (isOverdue) {
      return <span className={styles['is-overdue-wrapper']}>{overdueMsg}</span>
    }
    if (state === 4) {
      return null
    }
    if (expireTime === 0 || !expireTime) {
      return null
    }
    return (
      <CountDown
        seconds={expireTime}
        onTimeEnd={onTimeEnd}
        getDayWord={getDayWord}
        fromOverdueWord={fromOverdueWord}
      />
    )
  }
  const isNoBuyCoupon = buyDataSource.length === 0
  return (
    <div className={styles['new-user-content-wrapper']}>
      <div className={styles['font-img-wrapper']}>
        <img className={styles['font-img']} src={propsConfig.fontImg} alt="" />
      </div>
      <div
        className={classnames({
          [styles['count-down-wrapper']]: true,
          [styles['count-down-wrapper-nologin']]: state === 4,
        })}
      >
        {renderCountDown()}
      </div>
      <div className={styles['coupon-wrapper']}>
        {!!statusImgSrc && <img className={styles['status-img']} src={statusImgSrc} alt="" />}
        {isQuery && (
          <img
            className={styles['coupon-img']}
            src={
              isNoBuyCoupon
                ? propsConfig.noBuyCouponBgImg || propsConfig.couponBgImg
                : propsConfig.couponBgImg
            }
            alt=""
          />
        )}
        <div className={styles['coupon-content-wrapper']}>
          <BuyWrapper title={propsConfig.buyTitle} data={buyDataSource} />
          <SellWrapper title={propsConfig.sellTitle} data={sellDataSource} />
        </div>
      </div>
    </div>
  )
}

function OldUserContent() {
  const { sorryTopMsg, sorryBottomMsg } = useContext(Context)
  return (
    <div className={styles['old-user-content']}>
      <p className={styles['old-user-msg']}>{sorryTopMsg}</p>
      <p className={styles['old-user-msg']}>{sorryBottomMsg}</p>
    </div>
  )
}

function getSecond(ms: number): number {
  console.error(ms, 'ms...')
  if (typeof ms !== 'number') {
    return 0
  }
  return (ms - Date.now()) / 1000
}

/**
 * 影响因素
 * 1. 有无买家券
 * 2. 卖家券两行还是一行
 * 3. 登陆状态
 */
function getContainerHeight(
  isNewUser: boolean,
  isSellTwoLen: boolean,
  isNoBuyCoupon: boolean,
  isNoLogin: boolean
) {
  if (!isNewUser) {
    return 287
  }
  if (isNoBuyCoupon) {
    const diff = 20
    let base = 340
    if (isSellTwoLen) {
      base = 395
    }
    if (isNoLogin) {
      return base
    }
    return base + diff
  }
  if (isNoLogin) {
    return 467
  }
  return 487
}

// function Btn(props: { propsConfig: ItemProps; onClick: () => void; isBtnMsgGoUse: boolean }) {
//   const { propsConfig, onClick, isBtnMsgGoUse } = props
//   const { goHomeBtnWord, justUseBtnWord } = useContext(Context)

//   return (
//     <div className={styles['bottom-img-wrapper']}>
//       <img className={styles['bottom-img']} src={propsConfig.bottomBgImg} alt="" />
//       <div onClick={onClick} className={styles['bottom-btn']}>
//         {isBtnMsgGoUse ? justUseBtnWord : goHomeBtnWord}
//         {isBtnMsgGoUse && (
//           <img
//             className={styles['bottom-btn-img']}
//             src="https://cdn.poizon.com/node-common/048d0fb6eea84db1cdea60ad423656f6.png"
//             alt=""
//           />
//         )}
//       </div>
//     </div>
//   )
// }

const defaultInit: CouponInfoModleItemType = {
  ownerType: 1,
  useLimit: 2,
  couponType: 1,
  limitAmount: 0,
  deductionAmount: 0,
}

function genDefaultData(len: number): CouponInfoModleItemType[] {
  return new Array(len).fill(defaultInit)
}

@withReactTrack({ createTrackConfig })
class PoizonNewUserCoupon extends Component<IProps, IState> {
  static config = {
    name: 'poizon-new-user-coupon',
  }

  constructor(props: IProps) {
    super(props)
    this.state = {
      // 8 张
      // buyDataSource: genDefaultData(8),
      buyDataSource: [],
      // 2 张
      sellDataSource: genDefaultData(2),
      state: 4,
      expireTime: 0,
    }
    if (props?.editConfig?.lang) {
      this.lang = langMap[props.editConfig.lang] || langMap.en
    } else {
      this.lang = langMap.en
    }
    this.isQuery = false
  }

  lang: LangType
  isNewUser: boolean
  isOverdue: boolean
  isBtnMsgGoUse: boolean
  isNoLogin: boolean
  productRef: any
  isQuery: boolean
  componentDidMount() {
    this.queryData()
  }

  queryData = () => {
    const { lang, local, id } = this.props?.editConfig
    receiveCoupon({
      language: lang,
      countryCode: local,
      marketingType: 3,
      currencyCode: currencyCodeMap[local],
      uniqueMark: id,
    })
      .then((result) => {
        const res = result.data
        if (res) {
          this.isQuery = true
          this.setState({
            // 状态兜底
            // 如果状态返回5，则 状态为3
            state: res.state === 5 ? 3 : res.state,
            expireTime: getSecond(res.expireTime),
            buyDataSource: res.couponInfoModleList.filter((it) => it.ownerType == 1),
            sellDataSource: res.couponInfoModleList.filter((it) => it.ownerType == 2),
          })
          // 刚领取有个Toast
          if (res.state === 6) {
            Toast.info(this.lang.receivedMsg)
          }
          Jockey.receiveH5Data('adActivity', {
            advType: 11,
            state: res.state,
          })
          // 此处有个Jockey
        }
      })
      .catch(() => {
        this.isQuery = true
      })
  }

  onTimeEnd = () => {
    // 还是重新查一下数据？
    this.setState({
      state: 3,
    })
  }

  onBtnClick = () => {
    if (!isDuApp()) {
      appInstall()
      return
    }
    const { state } = this.state
    const isBtnMsgGoUse = state === 1 || state === 4 || state === 6
    if (isBtnMsgGoUse) {
      console.error(this.productRef, 'productRef...')
      if (this.productRef && this.productRef.offsetTop) {
        window.scrollTo(0, this.productRef.offsetTop)
      }
    } else {
      // 去首页逛逛
      Jockey.closeCurrentPage()
    }
  }

  getRef = (ref) => {
    this.productRef = ref
  }

  render() {
    const { propsConfig, editConfig } = this.props
    const { buyDataSource, sellDataSource, state, expireTime } = this.state
    if (!propsConfig || !editConfig) {
      return <div>请填写属性</div>
    }
    // TODO 改成枚举
    const isNewUser = state !== 2
    const isOverdue = state === 3
    const isBtnMsgGoUse = state === 1 || state === 4 || state === 6
    const isNoLogin = state === 4

    this.isNewUser = isNewUser
    this.isOverdue = isOverdue
    this.isBtnMsgGoUse = isBtnMsgGoUse
    this.isNoLogin = isNoLogin

    // 澳门 台湾没有买家券 fix
    const isNoBuyCoupon = buyDataSource.length === 0
    const isSellTwoLen = sellDataSource.length > 3
    const containerHeight = getContainerHeight(isNewUser, isSellTwoLen, isNoBuyCoupon, isNoLogin)
    return (
      <div>
        <Fragment>
          <Context.Provider
            value={{
              isQuery: this.isQuery,
              lang: editConfig.lang,
              currencyCode: currencySymbolMap[editConfig?.local] || 'HK$',
              ...this.lang,
            }}
          >
            <div
              className={classnames({
                [styles['new-user-coupon']]: true,
                [styles['is-new-user-wrapper']]: isNewUser,
                [styles['is-old-user-wrapper']]: !isNewUser,
                [styles['is-no-login-wrapper']]: isNoLogin,
                [styles['no-buy-wrapper']]: isNoBuyCoupon,
                [styles['no-buy-and-sell-2-line']]: isNoBuyCoupon && isSellTwoLen,
                [styles['no-buy-and-sell-1-line']]: isNoBuyCoupon && !isSellTwoLen,
              })}
              style={{ height: px2rem(containerHeight) }}
              data-track-exposure="poizon_venue_component_content_exposure"
            >
              <img className={styles['bg-img']} src={propsConfig.outerBgImg} alt="" />
              {isNewUser ? (
                <NewUserContent
                  expireTime={expireTime}
                  sellDataSource={sellDataSource}
                  buyDataSource={buyDataSource}
                  onTimeEnd={this.onTimeEnd}
                  propsConfig={propsConfig}
                  isOverdue={isOverdue}
                  state={state}
                />
              ) : (
                <OldUserContent />
              )}
              <div className={styles['bottom-img-wrapper']}>
                <img className={styles['bottom-img']} src={propsConfig.bottomBgImg} alt="" />
                <div
                  data-track-click="poizon_venue_component_content_click"
                  onClick={this.onBtnClick}
                  className={styles['bottom-btn']}
                >
                  {isBtnMsgGoUse ? this.lang.justUseBtnWord : this.lang.goHomeBtnWord}
                  {isBtnMsgGoUse && (
                    <img
                      className={styles['bottom-btn-img']}
                      src="https://cdn.poizon.com/node-common/048d0fb6eea84db1cdea60ad423656f6.png"
                      alt=""
                    />
                  )}
                </div>
              </div>
            </div>
          </Context.Provider>
          <Product {...this.props} getRef={this.getRef} />
        </Fragment>
      </div>
    )
  }
}

PoizonNewUserCoupon.config = {
  name: 'poizon-new-user-coupon-old',
}

export default PoizonNewUserCoupon
